export const config = {
  siteName: "Yati Labs",
  appUrl: "https://www.yatilabs.com/",
  contactFrom: "https://www.yatilabs.com/send/",
  // serverUrl: "http://127.0.0.1:5000/",
  serverUrl: "https://www.yatilabs.com/",
};
